module.exports = __webpack_public_path__ + "img/cancelled_delivery.c7efe95e.svg";